import { MessageType } from '@acs-manageability/core'

export default class TurnAuthentication {
  constructor(webSocketConnection, broker, promiseResolver) {
    this.webSocketConnection = webSocketConnection
    this.broker = broker
    this.promiseResolver = promiseResolver
  }

  async getTurnCredentials(deviceId, username) {
    return new Promise((resolve, reject) => {
      this.promiseResolver.setPromiseReject(reject)
      this.promiseResolver.setPromiseResolve(resolve)

      const brokerMessage = this.broker.getMessage(MessageType.GET_TURN_CREDENTIALS, username)
      const message = {
        message_type: MessageType.GET_TURN_CREDENTIALS,
        to: deviceId,
        content: brokerMessage,
      }

      this.webSocketConnection.sendMessage(message)
    })
  }
}
